
  import {Component, Vue} from 'vue-property-decorator';
  import {Getter} from 'vuex-class';

  import NoData from '@/core/components/NoData.vue';

  import FilterDay from '../components/FilterDay.vue';
  import ListCards from '../components/ListCards.vue';
  import SelectProductType from '../components/SelectProductType.vue';

  @Component({
    components: {
      FilterDay,
      ListCards,
      NoData,
      SelectProductType,
    },
  })
  export default class Menu extends Vue {
    @Getter('menusAvailable', {namespace: 'menu'}) menusAvailable!: boolean;

    @Getter('hasArticles', {namespace: 'article'}) hasArticles!: boolean;

    @Getter('name', {namespace: 'site'}) siteName!: string;

    @Getter('loadingMenu', {namespace: 'menu'}) loadingMenu!: boolean;

    @Getter('loading', {namespace: 'site'}) loading!: boolean;
  }
